/**
 * Общее поведение форм входа, регистрации и восстановления пароля.
 * Разметка этих форм — в `components/authForm.tsx`.
 */
import i18next from "i18next";
import { useCallback, useState } from "react";

import { ApiError } from "../api/client";
import { useAuthSettings } from "../api/queries";
import { resetCaptcha } from "./captcha";

/**
 * Общее для всех форм состояние капчи.
 *
 * Токен одноразовый: после отказа сервера виджет нужно сбросить, иначе
 * повторная отправка уйдёт с уже использованным токеном и снова не пройдёт.
 */
export function useCaptcha() {
  const settings = useAuthSettings();
  const [token, setToken] = useState<string | null>(null);

  const required = settings.data?.captchaRequired ?? false;
  const siteKey = settings.data?.captchaSiteKey ?? "";

  const reset = useCallback(() => {
    if (!required) return;
    resetCaptcha();
    setToken(null);
  }, [required]);

  return {
    settings,
    siteKey,
    required,
    token,
    setToken,
    reset,
    /** Форму нельзя отправлять, пока проверка не пройдена. */
    blocked: required && !token,
  };
}

/** Сообщение сервера показывается как есть: оно уже написано для человека. */
export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) return error.message;
  return i18next.t("error.network");
}
